import { termCondition } from "../api/termCondition";
export const getTermCondition = () => {
  return termCondition.get().then(response => response);
};
